module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitleRegister: 'S’inscrire auprès de sephora',
        modalTitleCreate: 'Créer un compte',
        biBenefitsDescription: 'Inscrivez-vous pour bénéficier de ces privilèges exclusifs :',
        freeBirthdayGift: 'Cadeau<br>d’anniversaire gratuit',
        seasonalEvent: 'Économies<br>saisonnières',
        sampleRewards: 'Échantillons<br>de récompenses'
    };

    return resources[label];
};
